import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import FTM from './FTM';
import IntroM from './IntroM';
import ResultsM from './ResultsM';
import SUGM from './SUGM';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;

const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};
const ModelLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#MModel') {
      setBackI(appColors['ColorB']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#FTM') {
      setBackI('transparent');
      setBackII(appColors['ColorB']);
      setBackIII('transparent');
      setBackIV('transparent');
    } else if (key === '#SUGM') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorB']);
      setBackIV('transparent');
    } else if (key === '#ResultsM') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorB']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#MModel' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>Introduction</Text></Content>}/>
          <Link href='#FTM' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorB'], fontSize: '1.2vh'}}>Fundamentals and troubleshooting</Text></Content>}/>
          <Link href='#SUGM' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorB'], fontSize: '1.7vh'}}> Software usage guide</Text></Content>}/>
          <Link href='#ResultsM' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorB'], fontSize: '3vh'}}>Results</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorB'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}> 3D&nbsp;<br/> &nbsp;<br/> s&nbsp;<br/> s&nbsp;<br/> D&nbsp;<br/> N&nbsp;<br/> A&nbsp;</p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0', background: 'transparent'}}>
            <div id='MModel'>
              <IntroM/>
            </div>
            <div id='FTM'>
              <FTM/>
            </div>
            <div id='SUGM'>
              <SUGM/>
            </div>
            <div id='ResultsM'>
              <ResultsM/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default ModelLogic;
